<!-- Main container -->
@let strategy = strategy$ | async;
@let shape = shape$ | async;
@let sizeConstraint = sizeConstraint$ | async;
<!-- todo: combine-->
@if (strategy && shape && sizeConstraint) {
  <div class="layout-row full">
    <div class="flex place-start-center">
      @switch (strategy) {
        @case (Strategy.BOX) {
          <div class="layout-row gap-lg">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{ 'packaging.shape.constraint.maxWidth' | translate }}</mat-label>
              <elder-quantity-input
                placeholder="{{ 'packaging.shape.constraint.maxWidth' | translate }}"
                [(quantityValue)]="sizeConstraint.maxWidth.value"
                [unit]="sizeConstraint.maxWidth.unit"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{ 'packaging.shape.constraint.maxHeight' | translate }}</mat-label>
              <elder-quantity-input
                placeholder="{{ 'packaging.shape.constraint.maxHeight' | translate }}"
                [(quantityValue)]="sizeConstraint.maxHeight.value"
                [unit]="sizeConstraint.maxHeight.unit"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{ 'packaging.shape.constraint.maxLength' | translate }}</mat-label>
              <elder-quantity-input
                placeholder="{{ 'packaging.shape.constraint.maxLength' | translate }}"
                [(quantityValue)]="sizeConstraint.maxLength.value"
                [unit]="sizeConstraint.maxLength.unit"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
        }
        @case (Strategy.RECTANGLE) {
          <div class="layout-row gap-lg">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{ 'packaging.shape.constraint.maxWidth' | translate }}</mat-label>
              <elder-quantity-input
                placeholder="{{ 'packaging.shape.constraint.maxWidth' | translate }}"
                [(quantityValue)]="sizeConstraint.maxWidth.value"
                [unit]="sizeConstraint.maxWidth.unit"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>{{ 'packaging.shape.constraint.maxHeight' | translate }}</mat-label>
              <elder-quantity-input
                placeholder="{{ 'packaging.shape.constraint.maxHeight' | translate }}"
                [(quantityValue)]="sizeConstraint.maxHeight.value"
                [unit]="sizeConstraint.maxHeight.unit"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
        }
        @case (Strategy.VOLUME) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'packaging.shape.constraint.maxVolume' | translate }}</mat-label>
            <elder-quantity-input
              placeholder="{{ 'packaging.shape.constraint.maxVolume' | translate }}"
              [(quantityValue)]="sizeConstraint.maxVolume.value"
              [unit]="sizeConstraint.maxVolume.unit"
            >
            </elder-quantity-input>
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        }
        @case (Strategy.AREA) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'packaging.shape.constraint.maxArea' | translate }}</mat-label>
            <elder-quantity-input
              placeholder="{{ 'packaging.shape.constraint.maxArea' | translate }}"
              [(quantityValue)]="sizeConstraint.maxArea.value"
              [unit]="sizeConstraint.maxArea.unit"
            >
            </elder-quantity-input>
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        }
      }
    </div>
  </div>
}
